/* @flow */

import React from 'react';
import { render } from 'react-dom';
import api from '../utils/api';

const boxSelecionarPlano = document.getElementById('boxSelecionarPlano');
const boxSelecionarPlanoFormulario = document.getElementById('boxSelecionarPlanoFormulario');

if (boxSelecionarPlano && boxSelecionarPlanoFormulario) {
    Promise.all([
        import('./planos/SelecionarPlano').then(module => module.default),
        import('./planos/SelecionarPlanoFormulario').then(module => module.default),
        api.getPlanos(),
    ])
        .then(([SelecionarPlano, SelecionarPlanoFormulario, { data: planos }]) => {
            render(<SelecionarPlano planos={planos} />, boxSelecionarPlano);
            render(<SelecionarPlanoFormulario planos={planos} />, boxSelecionarPlanoFormulario);
        });
}
